import { create } from 'zustand';

interface ThemeState {
    darkMode: boolean;
    toggleDarkMode: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
    darkMode: localStorage.getItem('darkMode') === 'true',
    toggleDarkMode: () =>
        set((state) => {
            const next = !state.darkMode;
            localStorage.setItem('darkMode', String(next));
            return { darkMode: next };
        }),
}));

interface SettingsState {
    exchangeRate: number; // USD to CNY
    setExchangeRate: (rate: number) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
    exchangeRate: parseFloat(localStorage.getItem('exchangeRate') || '7.25'),
    setExchangeRate: (rate: number) => {
        localStorage.setItem('exchangeRate', String(rate));
        set({ exchangeRate: rate });
    },
}));
